import {
  map, split, replace, mapKeys,
  mapValues, first, last, toUpper,
  size, startsWith, get,
} from 'lodash';
import spacetime from 'spacetime';
import isValidEmail from 'validator/lib/isEmail';
import { isValidNumber, parsePhoneNumberFromString } from 'libphonenumber-js';
import { validate as validatePostalCode } from 'postal-codes-js';
import metadata from './libphonenumber-metadata.json';

const countryCode = 'CA';
const countryPhonePrefix = '+1';

export const isEmail = isValidEmail;

export function getSearchParams(search) {
  return mapValues(
    mapKeys(
      map(
        split(
          replace(search, /^\?/, ''), '&',
        ),
        param => split(decodeURIComponent(param), '='),
      ),
      first,
    ),
    last,
  );
}

export function isPhoneNumber(number) {
  return isValidNumber(startsWith(number, countryPhonePrefix) ? number : `${countryPhonePrefix}${number}`, metadata);
}

export function isPostalCode(code) {
  return validatePostalCode(countryCode, code);
}

export function formatPostalCode(code) {
  const c = replace(code, /[ |-]/g, '');
  if (isPostalCode(code) === true && size(c) === 6) {
    return toUpper([c.substr(0, 3), c.substr(3)].join(' '));
  }
  return toUpper(code);
}

export function formatPhoneNumber(number) {
  try {
    return parsePhoneNumberFromString(startsWith(number, countryPhonePrefix) ? number : `${countryPhonePrefix}${number}`).formatNational();
  } catch (e) {
    return number;
  }
}

export function getDate(day = {}, exclusiveOffset = 0) {
  const { value, inclusive } = day;
  if (value) {
    if (!inclusive) {
      return spacetime(value).add(exclusiveOffset, 'day');
    }
    return value;
  }
  return null;
}

export function getDuration(duration) {
  const start = getDate(get(duration, 'start'), 1);
  const end = getDate(get(duration, 'end'), -1);
  return { start, end };
}

export function dateFormat(date, format = '{date-pad} {month-short} {year}') {
  return spacetime(date).format(format);
}
